import React, { useEffect, useRef, useState } from 'react'
import { colorShareState } from './detectors/colorDetector'
import styles from './Vision.module.css'

// Draggable box over the video that marks the region the colour "Aim" mode
// samples. Writes its normalized position into colorShareState.aimBox, which the
// detector reads each frame. Only shown while Aim is on.
const ColorAimBox = () => {
    const wrapRef = useRef(null)
    const [, force] = useState(0)
    const [aim, setAim] = useState(colorShareState.aim)

    useEffect(() => {
        const t = setInterval(() => setAim(colorShareState.aim), 150)
        return () => clearInterval(t)
    }, [])

    const onDown = (e) => {
        e.preventDefault()
        const stage = wrapRef.current && wrapRef.current.parentElement
        if (!stage) return
        const rect = stage.getBoundingClientRect()
        const move = (ev) => {
            const b = colorShareState.aimBox
            const nx = (ev.clientX - rect.left) / rect.width - b.w / 2
            const ny = (ev.clientY - rect.top) / rect.height - b.h / 2
            colorShareState.aimBox = {
                ...b,
                x: Math.max(0, Math.min(1 - b.w, nx)),
                y: Math.max(0, Math.min(1 - b.h, ny)),
            }
            force((n) => n + 1)
        }
        const up = () => {
            window.removeEventListener('pointermove', move)
            window.removeEventListener('pointerup', up)
        }
        window.addEventListener('pointermove', move)
        window.addEventListener('pointerup', up)
    }

    if (!aim) return null
    const box = colorShareState.aimBox
    return (
        <div
            ref={wrapRef}
            className={styles.aimBox}
            style={{
                left: `${box.x * 100}%`,
                top: `${box.y * 100}%`,
                width: `${box.w * 100}%`,
                height: `${box.h * 100}%`,
            }}
            onPointerDown={onDown}
        />
    )
}

export default ColorAimBox
